import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  RollbackOutlined
} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {SubscriptionFieldsFragment, SubscriptionStatus} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  subscription: SubscriptionFieldsFragment;
}

export const SubscriptionStatusTag: React.FC<Props> = ({subscription, ...props}) => {
  switch (subscription.status) {
    case SubscriptionStatus.PENDING:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Pending</span> <ClockCircleOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.ACTIVE:
      return (
        <StatusTag {...props} color={colors.success}>
          <span className="label">Active</span> <CheckOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.CANCELED:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Canceled</span> <CloseOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.EXPIRED:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Expired</span> <CloseOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.PAUSED:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Paused</span> <ClockCircleOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.PAST_DUE:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Past due</span> <ClockCircleOutlined />
        </StatusTag>
      );
    case SubscriptionStatus.TRIALING:
      return (
        <StatusTag {...props} color={colors.grey}>
          <span className="label">Trialing</span> <ClockCircleOutlined />
        </StatusTag>
      );
  }

  return null;
};
